namespace TabAurous.ECommerce {
    export interface ECommSalesPromoRow {
        TransPromoId?: number;
        TransId?: number;
        PromoId?: number;
        ProductTypeId?: number;
        TotalAmount?: number;
        PromoPer?: number;
        PromoAmount?: number;
        ProductTypeName?: string;
        PromoCode?: string;
        PromoName?: string;
    }

    export namespace ECommSalesPromoRow {
        export const idProperty = 'TransPromoId';
        export const localTextPrefix = 'ECommerce.ECommSalesPromo';
        export const deletePermission = 'EComm:ECommSales:Delete';
        export const insertPermission = 'EComm:ECommSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSales:Edit';

        export declare const enum Fields {
            TransPromoId = "TransPromoId",
            TransId = "TransId",
            PromoId = "PromoId",
            ProductTypeId = "ProductTypeId",
            TotalAmount = "TotalAmount",
            PromoPer = "PromoPer",
            PromoAmount = "PromoAmount",
            ProductTypeName = "ProductTypeName",
            PromoCode = "PromoCode",
            PromoName = "PromoName"
        }
    }
}
